module.exports = __webpack_public_path__ + "img/007-umbrella.e98c6fef.svg";